import React from 'react'
import PropTypes from 'prop-types'
import ArticleEventInfo from '@/component/Primitive/ArticleEventInfo'

const ArticleLayoutEventInfoWidget = ({ article }) => {
  if (!article || article.contentType !== 'Event') return null

  const { _id, startDate, endDate, address, price, eventBriteId } = article

  return (
    <ArticleEventInfo
      {...{
        _id,
        startDate,
        endDate,
        address,
        price,
        eventBriteId
      }}
    />
  )
}

ArticleLayoutEventInfoWidget.propTypes = {
  article: PropTypes.object
}

export default ArticleLayoutEventInfoWidget
